import { isUndefined, isFunction, noop } from 'lodash';
import Icon from '../icons';

const trophyIcon = Icon({
  type: 'trophy',
  color: 'rgb(245, 212, 85)',
  size: 16,
});
const clockIcon = Icon({ type: 'clock', color: '#848d9e', size: 16 });

class Homescreen {
  constructor(props) {
    this.getText = Pollfish.ui.getText;
    this.props = {
      onStartSurvey: props.onStartSurvey,
      onNoThanks: props.onNoThanks,
      onShowTerms: props.onShowTerms,
    };
  }

  renderHeader = () => {
    const { getText } = this;
    const surveyLOI = this.getSurveyLOI();

    let title = getText('surveyPromptNoIncentive', surveyLOI);
    title = Pollfish.helper.is3rdParty()
      ? title.replace(/<span.*<\/span>/g, '')
      : title;
    return title;
  };

  getSurveyLOI = () => {
    let { survey_loi: surveyLOI } = Pollfish.helper.json;

    // for safety https://pollfish.atlassian.net/browse/PUB-1794
    if (isUndefined(surveyLOI)) {
      ({ surveyLOI } = Pollfish.helper);
    }

    return surveyLOI;
  };

  renderImg = () => {
    // incentive was the amazon gift cards that have been deprecated
    let type = 'non-incentive';

    let imgEl = `
      <div class="card__image card__image--no-margin card__image--${type}">
        <div class="card__image-svg card__image-svg--${type}"></div>
      </div>
    `;

    if (
      !Pollfish.helper.whiteLabelEnabled() &&
      Pollfish.helper.json.theme_logo
    ) {
      type = 'custom-logo';
      imgEl = `
        <div class="card__image card__image--no-margin card__image--${type}">
          <img src="${Pollfish.helper.json.theme_logo}" alt="" style="max-height: 160px; max-width: 100%;" />
        </div>
      `;
    }

    return imgEl;
  };

  render3dParty = () => {
    const { getText } = this;
    let content = '';

    if (Pollfish.helper.is3rdParty() && !Pollfish.helper.opensInWebview()) {
      content = `
        <div class="text-sm text-grey margin-xl-top opens-in-browser">
          ${getText('opens_in_browser')}
        </div>
      `;
    } else {
      content = `
        <div class="text-sm text-light margin-xl-top opens-in-browser font-bold">
          ${getText('anonymous_responses')}
        </div>
      `;
    }

    return content;
  };

  renderRewards = () => {
    const {
      reward_settings_enabled: rewardsEnabled,
      reward_name: rewardName,
      reward_value: rewardValue,
    } = Pollfish.helper.json;

    const surveyLOI = this.getSurveyLOI();
    // we always show LOI even if no rewards are enabled
    if (!rewardsEnabled || !rewardName || !rewardValue) {
      return `
        <div>
          <p class="flex flex-align-items--center flex-1 flex-justify--center">
            <span class="margin-sm-left line-height-reset">${clockIcon}</span>
            <span class="font-bold" style="margin-left: 3px;">${surveyLOI}'</span>
          </p>
        </div>
      `;
    }

    return `
      <div>
        <p class="flex flex-align-items--center flex-1 flex-justify--center">
          <span class="line-height-reset">${trophyIcon}</span>
          <span style="margin-left: 3px" class="font-bold">${rewardValue}</span>
          <span class="margin-xxs-left">${rewardName}</span>
          <span class="margin-sm-left line-height-reset">${clockIcon}</span>
          <span class="font-bold" style="margin-left: 3px;">${surveyLOI}'</span>
        </p>
      </div>
    `;
  };

  renderAcceptanceInfo = () => {
    const { getText } = this;
    let text = getText('by_accepting_this_survey');
    if (Pollfish.helper.isAndroid() && Pollfish.helper.json.sdk_version < 34) {
      text = getText('android_notification');
    }
    const content = `
      <p class="text-xs text-light google-indicator margin-xl-btm">
        ${text}
      </p>
    `;

    return content;
  };

  renderTerms = () => {
    const { getText } = this;
    const text = getText('by_taking_survey');
    return `${text} <a href="#" class="js-terms">${getText(
      'notify_terms',
    )}</a>`;
  };

  render() {
    const { getText } = this;
    return `
      <div class="main-content__home">
        <h1 class="header-text">${this.renderHeader()}</h1>
        <div class="homescreen-card">
          <div class="card__header">
            ${this.renderImg()}
          </div>
          <div class="card__content">
            <div class="margin-lg-top margin-lg-btm">
            ${this.renderRewards()}
            </div>
            <div class="margin-lg-top">
              <a href="#" id="take-survey-btn" class="btn btn-primary btn-lg js-take-survey-btn">
                ${getText('take_survey_btn')}
              </a>
            </div>
            ${this.render3dParty()}
            ${this.renderAcceptanceInfo()}
          </div>
        </div>
        <div class="margin-xl-top">
          <a href="#" class="btn btn-xs btn-flat js-survey-reject-btn link-theme-hover">
            ${getText('no_thanks')}
          </a>
        </div>
      </div>
      <div class="footer">
        <p class="text-sm text-grey footer__terms">
          ${this.renderTerms()}
        </p>
      </div>`;
  }

  handleStartSurveyButton = (e) => {
    e.preventDefault();
    const { onStartSurvey = noop } = this.props;
    if (isFunction(onStartSurvey)) {
      onStartSurvey();
    }
  };

  handleNoThanksButton = (e) => {
    e.preventDefault();
    const { onNoThanks = noop } = this.props;
    if (isFunction(onNoThanks)) {
      onNoThanks();
    }
  };

  detachHandlers() {
    $('html').off('tap', '.js-take-survey-btn', this.handleStartSurveyButton);
    $('.main-content__home').off(
      'tap',
      '.js-survey-reject-btn',
      this.handleNoThanksButton,
    );
  }

  attachHandlers() {
    this.detachHandlers();
    $('html').on('tap', '.js-take-survey-btn', this.handleStartSurveyButton);
    // bind no thanks event
    Pollfish.event.noThanks();
  }
}

export default Homescreen;
